
export interface MembershipI {
    name: string,
    entries: number | null, 
    remaining_entries:number | null,
    unit: MembershipUnit | null | string,
    valid_from: Date | null,
    valid_to: Date | null,
    membership_id: number, //id_slevy,
    sports_ground_id: number,
    price_discount: number
}

export enum MembershipUnit {
    'time_hour' = 'time_hour',
    'time_minute' = 'time_minute',
    'amount' = 'amount',
    'entrie' = 'entrie',
    'price' = 'price'
}